import { Injectable } from '@angular/core';

export interface IAppSettingsService {
  get(key: string): any;
  set(key: string, value: any): void;
  clear(key: string): void;
  resetToDefault(): void;
}

// ANCHOR settings
export type Setting =
  | 'admin.session.token'
  | 'admin.session.expires'
  | 'admin.session.expires.as.date'
  | 'admin.session.duration'
  | 'admin.session.username'

export const SettingsKeys = {
  ACCESS_TOKEN: 'admin.session.token',
  ACCESS_TOKEN_EXPIRES: 'admin.session.expires',
  ACCESS_TOKEN_EXPIRES_AS_DATE: 'admin.session.expires.as.date',
  ACCESS_TOKEN_DURATION: 'admin.session.duration',
  ACCESS_USERNAME: 'admin.session.username',
} as const;

export const SETTINGS: Record<Setting, any> = {
  [SettingsKeys.ACCESS_TOKEN]: '',
  [SettingsKeys.ACCESS_TOKEN_EXPIRES]: 0,
  [SettingsKeys.ACCESS_TOKEN_EXPIRES_AS_DATE]: '',
  [SettingsKeys.ACCESS_TOKEN_DURATION]: 0,
  [SettingsKeys.ACCESS_USERNAME]:'',
} as const;

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {

  constructor() { }
  private storage = localStorage;

  private tryParseLocalStorageValue(value: any): any {
    let result = null;

    try {
      result = JSON.parse(value);
    } catch (ex: any) {
      console.log(ex);
      result = value;
    }

    return result;
  }

  get(setting: Setting): any {
    const storageValue = this.storage.getItem(setting);
    const result = this.tryParseLocalStorageValue(storageValue);

    return result ?? SETTINGS[setting];
  }

  set(setting: Setting, value: any): void {
    const settingValue = JSON.stringify(value ?? SETTINGS[setting]);

    this.storage.setItem(setting, settingValue);
  }

  clear(setting: Setting): void {
    this.storage.removeItem(setting);
  }

  resetToDefault(): void {
    this.storage.clear();

    const settings = Object.keys(SETTINGS) as Setting[];

    settings.forEach((key) => {
      const value = SETTINGS[key];

      if (value !== undefined) {
        this.set(key, value);
      }
    });
  }
}
